













































import Odd from '@core/models/offer/Odd';
import { useSwipe } from '@src/app/mobile/composition/useSwipe';
import {
    computed,
    defineComponent,
    PropType,
    ref,
} from '@vue/composition-api';
import SuperBet from './SuperBet.vue';
import { SdsButtonText } from '@superbet-group/web.lib.ui-components';

export default defineComponent({
    name: 'SuperBetSlider',
    props: {
        superbets: {
            type: Array as PropType<Odd[]>,
            required: true,
        },
        isEventLocked: {
            type: Boolean,
            required: true,
        },
        selectedOdds: {
            type: Set,
            required: true,
        },
        isResults: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    emits: [
        'showMore',
        'oddClick',
    ],
    setup(props) {
        const elRef = ref<HTMLElement>();
        const currentCardIndex = ref(0);

        const {
            onLeftSwipe,
            onRightSwipe,
        } = useSwipe(elRef);

        onRightSwipe(() => {
            currentCardIndex.value = Math.min(currentCardIndex.value + 1, props.superbets.length - 1);
        });

        onLeftSwipe(() => {
            currentCardIndex.value = Math.max(currentCardIndex.value - 1, 0);
        });

        function setCurrentIndex(index: number) {
            currentCardIndex.value = index;
        }

        return {
            elRef,
            currentCardIndex,
            setCurrentIndex,
            currentSuperbet: computed(() => props.superbets[currentCardIndex.value]),
        };
    },
    components: {
        SdsButtonText,
        SuperBet,
    },
});
